<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Main Specializations",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Main Specializations",
            items: [
               {
                  text: "Main Specializations",
                  active: true,
               },                   
            ],

            listing_length: 10,
            keyword: '',
            status: '',

            specializations: [],
            specialization: {
               id: "",
               specialization : "",
               specialist: "",
               image: "",
            },

            image: "",
            preview_image: "",
            
            modal_title: "Add Specialization",
            button_title: "Save",

            from: null,
            to: null,
            total: null,
            pagination: {},
            edit: false,
            specialization_status: {
               id: "",
               status: "",
            },
            token: "",
            errors: {},
            activate: false,
            deactivate: false,
            
            loading: false,

            active_page_url: null,
         };
      },
      mounted() {
         this.clearLocalStorage();

      },

      created() {
         this.fetchSpecializations();
      },

      methods: {
         clearLocalStorage() {
            localStorage.removeItem("consultation_filters");
            localStorage.removeItem("cancel_consultation_filters");
            localStorage.removeItem("patient_filters");
            localStorage.removeItem("doctor_filters");

         },

         fetchSpecializations(page_url = null) {

            this.getToken();
            let url = "api/admin/specializations?keyword=" + this.keyword + "&limit=" + this.listing_length + "&status=" + this.status;

            page_url = page_url || url;

            if(localStorage.back_url) {
               page_url = localStorage.back_url;  
               localStorage.removeItem('back_url');
            }    

            this.active_page_url = page_url;
            this.loading = true;
            
            this.$axios
               .get(page_url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.specializations = responseData.specializations.data;
                  
                  this.pagination = responseData.specializations.links;
                  this.from = responseData.specializations.from;
                  this.to = responseData.specializations.to;
                  this.total = responseData.specializations.total;
               
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         }, 

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         editSpecialization(specialization) {            
            this.modal_title = "Edit Specialization";
            this.button_title = "Update";
            this.specialization.id = specialization.id;
            this.specialization.specialization = specialization.specialization; 
            this.specialization.specialist = specialization.specialist;    
            this.specialization.image = specialization.image;    
            this.edit = true;
            this.showModal("specialization-modal");
         },

         addSpecialization() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url;
            let formData = new FormData();

            if(!this.edit) {
               url = "api/admin/specializations/add";
               this.active_page_url = null;

            } else {
               url = "api/admin/specializations/update";
               formData.append("specialization_id", this.specialization.id); 
            }         

            formData.append("specialization", this.specialization.specialization); 
            formData.append("specialist", this.specialization.specialist); 

            if(this.image) {
               formData.append("image", this.image); 
            }
            
            this.loading = true;
            
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.hideModal('specialization-modal');
                  this.fetchSpecializations(this.active_page_url);
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        //console.log(this.errors);
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         clearForm() {           
            this.modal_title = "Add Specialization";
            this.button_title = "Add";
            this.specialization.id = "";
            this.specialization.specialization = "";  
            this.specialization.specialist = ""; 
            this.specialization.image = "";
            this.image = "";
            this.preview_image = "";
            this.errors = {};
            this.edit = false;
         },

         activateSpecialization(specialization) {
            this.activate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to publish this specialization?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
              .then(value => {
                  this.activate = value
                  if(this.activate){
                  this.specialization_status.id = specialization.id;
                  this.specialization_status.status = 1;
                  this.updateSpecializationStatus();
               }
              })
               .catch(err => {
                  console.log(err);
              })
         },
         deactivateSpecialization(specialization) {
            this.deactivate = false;
              this.$bvModal.msgBoxConfirm('Are you sure you want to unpublish this specialization?', {
                  title: 'Confirm',
                  size: 'sm',
                  buttonSize: 'sm',
                  okVariant: 'danger',
                  okTitle: 'Yes',
                  cancelTitle: 'No',
                  footerClass: 'p-2',
                  hideHeaderClose: false,
                  centered: true
              })
               .then(value => {
                  this.deactivate = value
                  if(this.deactivate){
                  this.specialization_status.id = specialization.id;
                  this.specialization_status.status = 0;
                  this.updateSpecializationStatus();
               }
               })
               .catch(err => {
                  console.log(err);
               })
         },
         updateSpecializationStatus() {
            
            this.getToken();
            const config = {
               headers: {
                  "Content-type": "application/json",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };
            let url = "api/admin/specializations/status?specialization_id=" + this.specialization_status.id + "&status=" + this.specialization_status.status;
            this.$axios
               .get(url, config)
               .then((response) => {                  
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.fetchSpecializations(this.active_page_url);
               })
               .catch((error) => {                
                  if (error.response) {
                     if (error.response.data.message) {
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               });
         },
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <b-button v-b-modal.specialization-modal variant="primary" class="float-end">Add Main Specialization</b-button>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length" @change="fetchSpecializations()">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchSpecializations()"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status" @change="fetchSpecializations()">
                                 <option value="">All</option>
                                 <option value="1">Published</option>
                                 <option value="0">Unpublished</option>
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                               
                           <tr>
                              <th>Image</th>
                              <th>Specialization</th>
                              <th>Specialist</th>
                              <th>Created On</th>
                              <th>Options</th>                              
                           </tr>
                        </thead>
                        <tbody v-if="Boolean(specializations.length)">
                           <tr v-for="(specialization) in specializations" :key="specialization.id">
                              <td>
                                 <img v-if="specialization.image" :src="$image_url + specialization.image" class="avatar-sm rounded">
                                 <img v-else src="@/assets/images/no-image.png" class="avatar-sm rounded">
                              </td>  
                              <td>{{specialization.specialization}}</td>
                              <td>{{specialization.specialist}}</td>
                              <td>{{specialization.created_at | formatDateTime}}</td>
                              <td>
                                 <b-button variant="primary" class="btn-sm me-2 mt-2" @click="editSpecialization(specialization)">Edit</b-button>
                                 <router-link :to="{ name: 'subspecializations', params: {id: specialization.id} }" class="btn btn-primary btn-sm me-2 mt-2">Sub Specializations</router-link>
                                 <b-button v-if="specialization.status==1" variant="danger" class="btn-sm mt-2 me-2" @click="deactivateSpecialization(specialization)">Unpublish</b-button>

                                 <b-button v-else variant="success" class="btn-sm mt-2 me-2" @click="activateSpecialization(specialization)">Publish</b-button>
                              </td>
                           </tr>
                 
                        </tbody>
                        <tbody v-else>
                           <tr>
                              <td colspan="5" class="text-center">No specializations found</td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts ---> 
                  <caption v-if="Boolean(specializations.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                        <a href="#" class="page-link" @click.prevent="fetchSpecializations(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status )">
                           <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                           <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                           <span v-else>{{page.label}}</span>                          
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->
                  
                  <!---- modal starts ---->
                  <b-modal ref="specialization-modal" id="specialization-modal" :title="modal_title" hide-footer @hidden="clearForm()">
                     <b-form @submit.prevent="addSpecialization()">                        
                        <div class="row"> 
                           <b-form-group class="col-lg-12">
                              <label>Specialization <span class="text-danger">*</span> <span class="text-grey small">Eg: Gynaecology</span></label>
                              <b-form-input v-model="specialization.specialization" :class="{ 'is-invalid': Boolean(errors.specialization) }"></b-form-input>

                              <div v-for="(val, index) in errors.specialization" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-12">
                              <label>Specialist <span class="text-danger">*</span> <span class="text-grey small">Eg: Gynecologist</span></label>
                              <b-form-input v-model="specialization.specialist" :class="{ 'is-invalid': Boolean(errors.specialist) }"></b-form-input>

                              <div v-for="(val, index) in errors.specialist" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <div class="col-lg-12 mb-3">
                              <label>Image</label><br> 
                              <img v-if="specialization.image" :src="$image_url + specialization.image" alt="" class="avatar-sm mb-2">                         
                              <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                              <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                              <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </div>

                         

                           <b-col md="12" class="mt-3">
                              <b-button type="submit" class="me-3" variant="primary" :disabled="loading">
                                 <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 {{ loading ? 'Saving...' : button_title }}
                              </b-button>
                              <b-button class="" variant="light" @click="hideModal('specialization-modal')" :disabled="loading">Close</b-button>
                           </b-col>
                        </div>                       
                     </b-form>
                  </b-modal>
                  <!---- modal ends ----->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
